import { formatMapToOptions } from '@/utils/tool'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import { HIDE_FUNC } from '@/common/const/hide-function-config'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

export enum AreaType {
  normal = 1,
  linux = 2
}

export const AreaTypeLabel = {
  1: HIDE_FUNC.macos || IS_JP_ONLY_BUILD ? 'Windows/Server系统' : 'Windows/Server/MacOS系统',
  2: 'Linux及国产化系统'
}
// 日文模式隐藏linux选项
export const AreaTerminalTypes = {
  1: [TerminalType.windows, TerminalType.windowsServer, TerminalType.mac],
  2: IS_JP_ONLY_BUILD ? [] : [TerminalType.linux]
}

// 日文专用构建不展示 Linux 分区 Tab / 选项（与 AreaTerminalTypes 一致）
export const AreaTypeOption = formatMapToOptions(AreaTypeLabel).filter(
  opt => !IS_JP_ONLY_BUILD || +opt.value !== AreaType.linux
)
